export class TblUserData {
  id?: number;
  empId?: number;
  IsAuthorized?: boolean;
  AuthRequestId?: number;
  Message?: string;
  Type?: string;
  ExpirationDate?: string;
  CBExpirationDate?: string;
  WBExpirationDate?: string;
  IsFree?: boolean;
  IsYearlySubscribed?: boolean;
  IsMonthlySubscribed?: boolean;
  TopSubscriptionLine?: string;
  SecondSubscriptionLine?: string;
  ThirdSubscriptionLine?: string;
  EmailId?: string;
}
